import { ErrorMessage, Field, FieldProps, useField } from "formik";
import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { useTranslation } from "react-i18next";

interface TextareaInputProps {
    label?: string;
    placeholder: string;
    name: string;
    maxLength?: number;
    labelCol?: number;
    inputCol?: number;
    id: string;
    disabled?: boolean;
    disabledLabel?: boolean;
    required?: boolean;
    infoText?: string;
    inputColSm?: number;
    rightSlot?: React.ReactNode;
}

const TextareaInputWithCounter: React.FC<TextareaInputProps> = ({
    label,
    placeholder,
    name,
    maxLength,
    labelCol = 2,
    inputCol,
    id,
    disabled,
    disabledLabel,
    required,
    infoText,
    inputColSm,
    rightSlot,
}) => {
    const { t } = useTranslation();
    const [field] = useField(name);
    const [charCount, setCharCount] = useState(0);

    useEffect(() => {
        setCharCount(field?.value?.length || 0);
    }, [field.value]);

    return (
        <>
            {label ? (
                <Col sm={3} md={labelCol} className="mb-2 mb-md-0 text-start d-flex pt-6">
                    <label htmlFor={id} className={`${disabledLabel ? "text-secondary" : "text-dark"} fs-7 fw-bold`}>
                        <span>
                            {label}
                            {required && (
                                <span className={`${disabledLabel ? "text-$secondary" : "text-danger"} ps-1`}>*</span>
                            )}
                        </span>
                    </label>
                </Col>
            ) : null}
            <Col sm={inputColSm ? inputColSm : 9} md={inputCol}>
                <div className="position-relative text-start">
                    <Field name={name}>
                        {({ field, meta, form }: FieldProps) => (
                            <textarea
                                {...field}
                                id={id}
                                placeholder={placeholder}
                                className={`form-control ${meta.touched && meta.error ? "is-invalid" : ""} ${disabled && "text-secondary"} ${infoText || rightSlot ? "pe-7" : ""}${rightSlot ? " padding-background-position-is-invalid" : ""}`}
                                onBlur={() => form.setFieldTouched(field.name, true, true)}
                                maxLength={maxLength}
                                disabled={disabled}
                                value={field.value || ""}
                            />
                        )}
                    </Field>
                    {rightSlot ? (
                        <div
                            className={`position-absolute top-0 mt-1 d-flex align-items-center ${
                                infoText ? "end-0 me-7" : "end-0 me-2"
                            }`}
                        >
                            {rightSlot}
                        </div>
                    ) : null}
                    {infoText ? (
                        <OverlayTrigger overlay={<Tooltip placement="top">{t(infoText)}</Tooltip>}>
                            <i className="bi bi-info-circle pb position-absolute top-0 end-0  me-3 pt-6"></i>
                        </OverlayTrigger>
                    ) : null}
                    <span id="countSymbols" className="fs-7 lh-lg text-grey">
                        {charCount ? charCount : 0}/{maxLength}
                    </span>
                    <ErrorMessage name={name}>{(msg) => <div className="invalid-feedback">{msg}</div>}</ErrorMessage>
                </div>
            </Col>
        </>
    );
};

export default TextareaInputWithCounter;
